export function getRoot() {
    const protocol = window.location.protocol;
    const host = window.location.hostname;
    const port = window.location.port;
    if (port !== "80" && port!== "443") {
        return `${protocol}//${host}:${port}/`;
    }else{
        return `${protocol}//${host}/`;
    }
}